// extracted by mini-css-extract-plugin
export default {"wrapper":"PageContent_wrapper__s7bXy","start":"PageContent_start__oYRu2","center":"PageContent_center__PJka6","end":"PageContent_end__sSXgc"};